import React from 'react'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaGraduationCap, FaSchool } from 'react-icons/fa';

const EducationQualifications = () => {
  const education = [
    {
      id: 1,
      title: "B.E. IN INFORMATION TECHNOLOGY",
      school: "Vivekanand Education Society Institute Of Technology, Chembur",
      year: "2021-2025",
      score: "Avg CGPA - 9.35",
      icon: <FaGraduationCap />,
      description: "specialized in Information Technology with consistent academic performance."
    },
    {
      id: 2,
      title: "HIGHER SECONDARY EDUCATION",
      school: "P.S.B.A English School Aurangabad",
      year: "2019-2021",
      score: "Secured 86.20 %",
      icon: <FaSchool />,
      description: "Completed HSC with focus on Science and Mathematics."
    },
    {
      id: 3,
      title: "SENIOR SECONDARY EDUCATION",
      school: "St. Anne's High School Warora",
      year: "2019",
      score: "Secured 92.80 %",
      icon: <FaSchool />,
      description: "Completed SSC with distinction."
    }
  ];

  return (
    <div className="py-16 text-white">
      <h1 className="text-4xl font-bold text-center mb-16 font-serif bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600">
        EDUCATIONAL QUALIFICATIONS
      </h1>

      <VerticalTimeline>
        {education.map((item) => (
          <VerticalTimelineElement
            key={item.id}
            className="vertical-timeline-element--education"
            contentStyle={{
              background: 'rgba(255, 255, 255, 0.05)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              color: '#fff',
              borderRadius: '16px',
              boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)'
            }}
            contentArrowStyle={{ borderRight: '7px solid  rgba(255, 255, 255, 0.05)' }}
            date={item.year}
            iconStyle={{ background: '#4a00e0', color: '#fff' }}
            icon={item.icon}
          >
            <h3 className="vertical-timeline-element-title text-xl font-bold text-purple-400">
              {item.title}
            </h3>
            <h4 className="vertical-timeline-element-subtitle text-gray-300 mt-2">
              {item.school}
            </h4>
            <div className="mt-4">
              <span className="inline-block px-3 py-1 bg-purple-500/20 rounded-full text-purple-200 text-sm font-semibold border border-purple-500/30">
                {item.score}
              </span>
            </div>
            <p className="text-gray-400 text-sm mt-2">
              {item.description}
            </p>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
      <br /><br />
    </div>
  )
}

export default EducationQualifications
